var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'login-background': _vm.isLoginRoute },attrs:{"id":"main-wrapper"}},[_c('el-container',[_c('el-header',{attrs:{"height":"98px"}},[_c('menu-header')],1),_c('div',{staticClass:"content"},[_c('el-main',{attrs:{"id":"container"}},[_c('view-layout',[_c('router-view')],1)],1),_c('footer-bar')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }